import { useLanguage } from '../i18n/LanguageContext';
import { Reveal, Overline } from './motion';

export const NzebSection = () => {
  const { t } = useLanguage();
  const n = t('nzeb');
  if (!n) return null;

  return (
    <section data-testid="nzeb-section" className="bg-[#1B1D22] text-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="flex items-start justify-between gap-6 mb-4">
                <Overline className="!text-accent">{n.overline}</Overline>
                <img
                  src="/nzeb-badge.webp"
                  alt="Compatibil cu standardul nZEB"
                  data-testid="nzeb-badge"
                  loading="lazy"
                  decoding="async"
                  className="w-24 md:w-28 h-auto -mt-3 shrink-0"
                />
              </div>
              <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight mb-6">{n.title}</h2>
              <p data-testid="nzeb-lead" className="text-white/70 leading-relaxed mb-5">{n.lead}</p>
              <p data-testid="nzeb-body" className="text-white/50 text-sm leading-relaxed">{n.body}</p>
            </Reveal>
          </div>
          <div className="lg:col-span-7 flex flex-col justify-center">
            <div className="grid grid-cols-2 gap-px bg-white/10 border border-white/10">
              {n.stats.map((stat, i) => (
                <Reveal key={i} delay={i * 0.08}>
                  <div data-testid={`nzeb-stat-${i}`} className="bg-[#1B1D22] p-6 md:p-8 h-full hover:bg-[#22252B] transition-colors duration-500">
                    <span className="font-display text-sm text-accent tracking-[0.2em]">0{i + 1}</span>
                    <p className="font-display text-base md:text-lg font-medium mt-3 md:mt-4 leading-snug">{stat}</p>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal className="mt-8">
              <p data-testid="nzeb-note" className="text-white/60 text-sm border-l-2 border-accent pl-4">{n.note}</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
